import gql from 'graphql-tag'
export default gql`
  query UploadUrl ($contentType:String!,$seconds:Int) {
    UploadUrl (contentType:$contentType, seconds:$seconds) {
      SignedUrl{
        action
        expires
        url
        name
        seconds
      }
      uploadID
      contentType
    }
  }
`
